
define('text!modules/siteList/templates/list.html',[],function () { return '<div class="site-list-list-container">\n</div>';});

